import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const STOPCOMPENSATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StopCompensationType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const STOPCOMPENSATIONTYPE_CONFIG = {
  entityName: 'StopCompensationType',
  localizationKey: 'Controlling::Entity.StopCompensationType',
  fields: STOPCOMPENSATIONTYPE_FIELDS,
  permission: 'ControllingLiquidations.StopCompensationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
